import { render, staticRenderFns } from "./ShowCreatePostRounded.vue?vue&type=template&id=7a28f639"
import script from "./ShowCreatePostRounded.vue?vue&type=script&lang=js"
export * from "./ShowCreatePostRounded.vue?vue&type=script&lang=js"
import style0 from "./ShowCreatePostRounded.vue?vue&type=style&index=0&id=7a28f639&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports